module.exports = __webpack_public_path__ + "img/metal_ah@2x.b2f21619.png";